// Design System
import EmptyState from 'Components/DesignSystem/EmptyState/EmptyState';

// Constants
import { STRINGS } from '../constants';

/**
 * What both route entries render when no environment is selected.
 *
 * Cards live on a channel — every request the HTTP repository makes is
 * addressed by the selected environment's key — so until one is picked there
 * is genuinely nothing to load. Saying so beats the two dishonest options:
 * an empty listing (reads as "you have no cards") or the browser-storage
 * fallback (edits land in a store no other machine can see).
 */
const EnvironmentNotice = () => (
  <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
    <EmptyState size="sm" title={STRINGS.environment.noSelection} data-testid="product-cards-environment-notice" />
  </div>
);

export default EnvironmentNotice;
